
import { defineComponent } from "vue";
import TitlebarButtons from "@/components/shared/TitlebarButtons.vue"; // @ is an alias to /src
import axios from "axios";
import router from "@/router";

type Term = {
  term: string;
  target: { component: string; query: string } | { link: string };
};
export default defineComponent({
  name: "Search",
  components: {
    TitlebarButtons
  },
  data: () => ({
    title: "Suche",
    filter: "",
    terms: [] as Term[]
  }),
  emits: ["update-focus", "update-maximization"],
  created: function() {
    axios
      .get("./_content/search.json")
      .then((response) => response.data)
      .then(
        (terms) =>
          (this.terms = terms.filter(
            (t: Term) =>
              // eslint-disable-next-line no-prototype-builtins
              t.target.hasOwnProperty("component") ||
              // eslint-disable-next-line no-prototype-builtins
              t.target.hasOwnProperty("link")
          ))
      )
      .catch((error) => console.error(error));
  },
  methods: {
    updateFocus(focusValue: string) {
      this.$emit("update-focus", focusValue);
    },
    updateMaximization() {
      this.$emit("update-maximization", "search");
    },
    filteredSearchTerms() {
      return this.terms
        ?.filter((t) => t.term?.toLowerCase().match(this.filter?.toLowerCase()))
        ?.splice(0, 10);
    },
    navigateRoute(route: { component: string } & { link: string }, event: any) {
      // eslint-disable-next-line no-prototype-builtins
      if (route.hasOwnProperty("component")) {
        // const r = { c: route.c, q: q };
        router.push({ path: "", query: { c: route.component } });
        // eslint-disable-next-line no-prototype-builtins
      } else if (route.hasOwnProperty("link")) {
        window.open(route.link, "_blank");
      }
      event.stopPropagation();
    }
  }
});
